var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridV4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_11618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1669 1.83643H3.83354C2.91687 1.83643 2.16687 2.58643 2.16687 3.50309V16.8364C2.16687 17.7531 2.91687 18.5031 3.83354 18.5031H17.1669C18.0835 18.5031 18.8335 17.7531 18.8335 16.8364V3.50309C18.8335 2.58643 18.0835 1.83643 17.1669 1.83643ZM7.16687 16.8364H4.66687C4.20854 16.8364 3.83354 16.4614 3.83354 16.0031V13.5031H7.16687V16.8364ZM7.16687 11.8364H3.83354V8.50309H7.16687V11.8364ZM7.16687 6.83643H3.83354V4.33643C3.83354 3.87809 4.20854 3.50309 4.66687 3.50309H7.16687V6.83643ZM12.1669 16.8364H8.83354V13.5031H12.1669V16.8364ZM12.1669 11.8364H8.83354V8.50309H12.1669V11.8364ZM12.1669 6.83643H8.83354V3.50309H12.1669V6.83643ZM16.3335 16.8364H13.8335V13.5031H17.1669V16.0031C17.1669 16.4614 16.7919 16.8364 16.3335 16.8364ZM17.1669 11.8364H13.8335V8.50309H17.1669V11.8364ZM17.1669 6.83643H13.8335V3.50309H16.3335C16.7919 3.50309 17.1669 3.87809 17.1669 4.33643V6.83643Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_11618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.500244 0.169922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridV4);
export default __webpack_public_path__ + "static/media/GridV4.54b82449fb7710a4d65948e124118081.svg";
export { ForwardRef as ReactComponent };